export const blocksBaseUrl = 'https://blocks.wix.com';
